import React, { ReactElement } from 'react';

import { CloseRounded } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

import './_base.scss';

export type TAlertTypes = 'success' | 'error' | 'warning' | 'info';

export interface IProps {
  bold?: boolean;
  elevated?: boolean;
  text?: any;
  type?: TAlertTypes;
  icon?: ReactElement;
  onClose?: () => void;

  [x: string]: any;

  children?: React.ReactNode;
}

function Alert(props: IProps) {
  const { bold, children, elevated, icon, onClose, text, type } = props;

  const getClassName = () => {
    let classNameValue = 'simple-alert';
    classNameValue += type ? ' ' + type : '';
    classNameValue += bold ? '  bold' : '';
    classNameValue += elevated ? ' elevated' : '';
    return classNameValue;
  };

  return (
    <Box
      display='flex'
      flexDirection='row'
      alignItems='center'
      justifyContent='flex-start'
      className={getClassName()}>
      {icon && (
        <Box flexGrow={0} className='simple-alert-icon'>
          {icon}
        </Box>
      )}
      <Box flexGrow={1} className='simple-alert-text'>
        {text ? text : children}
      </Box>
      {onClose && (
        <Box flexGrow={0}>
          <IconButton
            color='inherit'
            size='small'
            className='simple-alert-close'
            onClick={() => onClose()}
            component='button'>
            <CloseRounded fontSize='inherit' />
          </IconButton>
        </Box>
      )}
    </Box>
  );
}

export default Alert;
